import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

declare global {
    interface HTMLScriptElement {
        readyState: string,
        onreadystatechange: (() => void) | null
    }
}

/**
 * Service to import additional javascript files at runtime
 */
@Injectable({
    providedIn: 'root'
})
export class AsyncScriptLoaderService {
    /**
     * Add a new script tag to the document and return an Observable
     * that fires when the script has finished loading.
     * 
     * @param options an id for the script tag and the url for the src
     */
    public loadScriptAsync(options: { id?: string, url: string }): Observable<any> {
        let subject = new Subject();
        let script = document.createElement("script")
        script.type = "text/javascript";

        if (options.id) {
            script.id = options.id;
        }

        if (script.readyState) {  //IE
            script.onreadystatechange = function () {
                if (script.readyState === "loaded" || script.readyState === "complete") {
                    script.onreadystatechange = null;
                    subject.next([]);
                }
            };
        } else {  //Others
            script.onload = () => {
                subject.next([])
            };
        }

        script.src = options.url;
        document.getElementsByTagName("head")[0].appendChild(script);

        return subject.asObservable();
    }
}
